import { WheelsDirection } from './wheels-direction';
import { WheelsFilters } from './wheels-filters';
import { WheelsPrice } from './wheels-pricing';

export class Wheels {
  public readonly Amount: number;
  public readonly NuProdQuant: number;
  public readonly address: string;
  public readonly city: string;
  public readonly item_id: string;
  public readonly item_name: string;
  public readonly price: number;
  public readonly quantity: number;
  public readonly startDate: string;
  public readonly startTime: string;
  public readonly total: number;
  public readonly type: 'wheels';
  public readonly vehicle: string;
  public readonly zipcode: string;
  public readonly zone: string;
  public readonly zoneDisplay: string;
  public readonly direction: WheelsDirection;

  constructor(wheelsFilters: WheelsFilters, wheelsPrice: WheelsPrice) {
    this.Amount = wheelsPrice.price;
    this.NuProdQuant = 1;
    this.address = wheelsFilters.address;
    this.city = wheelsFilters.city;
    this.direction = wheelsFilters.direction;
    this.item_id = `Wheels_${wheelsPrice.vehicleType}_${wheelsFilters.zone}`;
    this.item_name = `Wheels ${wheelsPrice.vehicleType} ${wheelsFilters.zone}`;
    this.price = wheelsPrice.price;
    this.quantity = 1;
    this.startDate = wheelsFilters.exitDate;
    this.startTime = wheelsFilters.exitTime;
    this.total = wheelsPrice.price;
    this.type = 'wheels';
    this.vehicle = wheelsPrice.vehicleType;
    this.zipcode = wheelsFilters.zipCode;
    this.zone = wheelsFilters.zone;
    this.zoneDisplay = wheelsFilters.zoneDisplay;
  }
}
